import { makeAutoObservable, runInAction } from "mobx";
import apiHandler from "../handlers/ApiHandler";

class CustomerStore {
  customers = [];
  organizations = [];
  locations = [];
  isLoading = false;
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchCustomers() {
    try {
      const response = await apiHandler.get("/api/customers");
      runInAction(() => {
        this.customers = response;
      });
    } catch (error) {
      this.error = error;
      console.error("Error fetching customers:", error);
    }
  }

  async fetchOrganizations() {
    try {
      const response = await apiHandler.get("/api/organizations");
      runInAction(() => {
        this.organizations = response;
      });
    } catch (error) {
      this.error = error;
      console.error("Error fetching organizations:", error);
    }
  }

  async fetchLocations() {
    try {
      const response = await apiHandler.get("/api/locations");
      runInAction(() => {
        this.locations = response;
      });
    } catch (error) {
      this.error = error;
      console.error("Error fetching locations:", error);
    }
  }

  async createCustomer(data) {
    const response = await apiHandler.post("/api/customers", data);
    runInAction(() => {
      this.customers.push(response);
    });
  }

  async updateCustomer(id, data) {
    const response = await apiHandler.put(`/api/customers/${id}`, data);
    runInAction(() => {
      const index = this.customers.findIndex((c) => c.id === id);
      if (index !== -1) this.customers[index] = response;
    });
  }

  async deleteCustomer(id) {
    await apiHandler.delete(`/api/customers/${id}`);
    runInAction(() => {
      this.customers = this.customers.filter((c) => c.id !== id);
    });
  }
}

const customerStore = new CustomerStore();
export default customerStore;
